import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { PrimaryButton, SecondaryButton } from "../components/UIkit";

const ProductMenu = () => {
  const dispatch = useDispatch();

  const transition = useCallback((path) => {
    dispatch(push(path));
  }, []);
  return (
    <div>
      <h2 className="u-text__headline u-text-center">商品登録</h2>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"商品を登録する"}
          onClick={() => transition("/product/edit")}
        />
      </div>
      {/* <TextDetail label="ユーザー名" value={username} /> */}
      <div className="module-spacer--small" />
      <div className="center">
        {/* <SecondaryButton label={"カード情報の編集"} onClick={() => transition('/user/payment/edit')} /> */}
        <SecondaryButton
          label={"商品を並び替える"}
          onClick={() => transition("/product/sorting")}
        />
      </div>
    </div>
  );
};

export default ProductMenu;
